import React, { useEffect, useState } from 'react';
import { Layout, Col, Row, Tabs, Modal, Typography, Table, Icon } from 'antd';

import TitleAndNew2 from '../Components/TitleAndNew2/TitleAndNew2';
import Description from '../Components/Description/Description';
import NewClaim from '../Components/Forms/NewClaim';
import { useDispatch, useSelector } from 'react-redux';
import {
  REQUEST_GET_USER_DATA_FOR_SELF,
  REQUEST_GET_SELF_CLAIMS,
} from '../Redux/constants/constants';
import api from '../Api/api';
import openErrorNotification from '../Utils/openErrorNotification';
import translateStatus from '../Utils/translateStatus';

const { Content } = Layout;
const { TabPane } = Tabs;
const { Title } = Typography;
const { Column } = Table;

const SelfService = () => {
  const dispatch = useDispatch();
  const selfData = useSelector((state) => state.selfData);
  const selfClaims = useSelector((state) => state.selfClaims);
  const [visible, setVisible] = useState(false);

  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const deleteClaim = (id) => {
    api
      .deleteClaim({ id })
      .then(() => {
        dispatch({ type: REQUEST_GET_SELF_CLAIMS });
      })
      .catch((e) => {
        openErrorNotification(e);
      });
  };

  useEffect(() => {
    dispatch({ type: REQUEST_GET_USER_DATA_FOR_SELF });
    dispatch({ type: REQUEST_GET_SELF_CLAIMS });
  }, []);

  return (
    <Layout>
      <Content style={{ margin: '36px' }}>
        <TitleAndNew2
          titleText={'Panel użytkownika'}
          buttonText={'Nowy wniosek'}
          action={showModal}
        />
        <Row gutter={16}>
          <Col span={7}>
            <div
              style={{
                background: '#fff',
                padding: '16px',
                borderRadius: '8px',
              }}
            >
              <Description
                description={'Dostępna ilość dni wolnych'}
                value={selfData.leftVacationDays}
              />
              <Description
                description={'Dostępna ilość nadgodzin'}
                value={selfData.availableOvertime}
              />
            </div>
          </Col>
          <Col span={17}>
            <div
              style={{
                background: '#fff',
                padding: '16px',
                borderRadius: '8px',
              }}
            >
              <Title
                level={3}
                style={{
                  marginBottom: '24px',
                  marginTop: '0px',
                  height: '36px',
                }}
              >
                Wnioski
              </Title>
              {/*<Tabs type="card">*/}
              {/*<TabPane tab="Statystyki" key="1">*/}
              {/*  <SelfStatsTable />*/}
              {/*</TabPane>*/}
              {/*  <TabPane tab="Wnioski" key="2">*/}
              {/*    <p>aaa</p>*/}
              {/*  </TabPane>*/}
              {/*</Tabs>*/}
              <Table
                pagination={false}
                rowKey={(record) => record.id}
                dataSource={selfClaims}
              >
                <Column title="Data" dataIndex="date" key="date" />
                <Column title="Typ" dataIndex="type" key="type" />
                <Column
                  title="Status"
                  dataIndex="status"
                  key="status"
                  render={(record) => translateStatus(record)}
                />
                <Column
                  title=" "
                  key="action"
                  render={(record) => (
                    <a
                      onClick={() => {
                        deleteClaim(record.id);
                      }}
                    >
                      <>
                        <Icon type="delete" theme="twoTone" />
                        <span> Usuń</span>
                      </>
                    </a>
                  )}
                />
              </Table>
            </div>
          </Col>
        </Row>
      </Content>
      <Modal
        title="Nowy wniosek"
        visible={visible}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose={true}
      >
        <NewClaim />
      </Modal>
    </Layout>
  );
};

export default SelfService;
